import React from "react";
import { useM } from "@/marketing/useM";
import { Reveal, Eyebrow, Rich, MkButton } from "@/marketing/ui";


const SECTIONS = [["s1", 3], ["s2", 2], ["s3", 2], ["s4", 1]];

const Block = ({ id, count, idx, m }) => (
  <Reveal className="grid gap-6 border-t border-white/10 py-14 lg:grid-cols-[1fr_1.6fr] lg:gap-16 lg:py-20">
    <div>
      <span className="font-mono-t text-xs text-mk-yellow">0{idx + 1}</span>
      <h2 className="mt-4 font-heading text-3xl font-extrabold uppercase leading-[0.95] text-white md:text-4xl" data-testid={`about-${id}-title`}>{m(`about.${id}.t`)}</h2>
    </div>
    <div className="space-y-5">
      {Array.from({ length: count }, (_, i) => (
        <p key={i} className="text-sm leading-relaxed text-white/70 md:text-lg">
          <Rich text={m(`about.${id}.p${i + 1}`)} />
        </p>
      ))}
    </div>
  </Reveal>
);

export default function About() {
  const m = useM();
  return (
    <div data-testid="about-page">
      <section className="relative overflow-hidden pb-20 pt-40 lg:pt-48">
        <img src="/media/hero-poster.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-mk-bg/60 via-mk-bg/80 to-mk-bg" />
        <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
          <Reveal>
            <Eyebrow>{m("about.eyebrow")}</Eyebrow>
            <h1 className="mt-6 max-w-5xl font-heading text-5xl font-black leading-[0.9] text-white sm:text-6xl lg:text-8xl" data-testid="about-title">{m("about.title1")}<br />{m("about.title2")}</h1>
          </Reveal>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-6 lg:px-10">
        {SECTIONS.map(([id, count], idx) => <Block key={id} id={id} count={count} idx={idx} m={m} />)}
      </section>
      <div className="border-t border-white/10">
        <div className="mx-auto grid max-w-7xl gap-6 px-6 pt-6 lg:grid-cols-[1fr_1.6fr] lg:gap-16 lg:px-10">
          <p className="font-mono-t text-xs uppercase tracking-[0.25em] text-mk-yellow lg:col-start-2" data-testid="about-founder-signature">{m("about.sign")}</p>
        </div>
      </div>
      <section className="px-6 py-28 lg:py-40">
        <Reveal className="mx-auto max-w-5xl text-center">
          <p className="font-heading text-4xl font-black uppercase leading-[0.95] text-white sm:text-5xl lg:text-7xl" data-testid="about-closing">{m("cta.title1")}<br /><span className="text-mk-yellow">{m("cta.title2")}</span></p>
          <MkButton to="/register" className="mt-12" data-testid="about-cta">{m("cta.btn")}</MkButton>
        </Reveal>
      </section>
    </div>
  );
}
